/* eslint-disable no-unused-vars */
import { Modal, Button } from 'antd';
import { useDispatch } from 'react-redux';

const { confirm } = Modal;

function DokanConfirmModal() {
    return confirm({
        title: 'Do you want to delete these items?',
        content: 'When clicked the OK button, this dialog will be closed after 1 second',
        onOk() {
            return 'deleteOk';
        },
        onCancel() {},
    });
}

export default DokanConfirmModal;
